import { XYChartTooltipContent } from './XYChartTooltipContent.js';
import {
  useSelector,
  useTooltipSnapshot,
} from '../../../core/components/overlay-tooltip/selectors.js';
import { isTooltipDataEmpty } from '../../../core/components/overlay-tooltip/utils.js';
import type { TooltipContent } from '../../types/state.js';

export const XYChartOverlayTooltip = () => {
  useSelector(
    ({ pinned, relativeX, relativeY }) => `${pinned}-${relativeX}-${relativeY}`,
  );
  const { data } = useTooltipSnapshot();

  if (isTooltipDataEmpty(data)) {
    return null;
  }

  return <XYChartTooltipContent content={data.metadata as TooltipContent} />;
};

XYChartOverlayTooltip['displayName'] = 'XYChartOverlayTooltip';
